<ng-container *ngIf="data">
  <div *ngIf="isLoading" class="full-size d-flex justify-content-center align-items-center">
    <div class="pb-2">
      <i class="fas fa-spin fa-spinner fa-2x text-{{theme.brightContrast}}"></i>
    </div>
  </div>

  <iframe [hidden]="isLoading" (load)="isLoading=false" class="full-size" [src]="src" [title]="data.title"></iframe>
</ng-container>